@if (confirmService.visible()) {
  <div class="cd-overlay" (click)="confirmService.cancel()">
    <div class="cd-dialog" [attr.data-variant]="confirmService.options().variant" role="alertdialog" aria-modal="true" aria-labelledby="cd-titre" aria-describedby="cd-message" (click)="$event.stopPropagation()">
      <div class="cd-icon-wrap">
        <div class="cd-icon">
          @switch (confirmService.options().variant) {
            @case ('danger') {
              <i class="pi pi-trash"></i>
            }
            @case ('recover') {
              <i class="pi pi-refresh"></i>
            }
            @case ('warning') {
              <i class="pi pi-exclamation-triangle"></i>
            }
            @case ('save') {
              <i class="pi pi-save"></i>
            }
            @case ('update') {
              <i class="pi pi-pencil"></i>
            }
            @default {
              <i class="pi pi-info-circle"></i>
            }
          }
        </div>
      </div>
      <h3 class="cd-title" id="cd-titre">{{ confirmService.options().title }}</h3>
      <p class="cd-message" id="cd-message">{{ confirmService.options().message }}</p>
      <div class="cd-actions">
        <button class="cd-btn cd-btn-cancel" (click)="confirmService.cancel()">
          {{ confirmService.options().cancelLabel }}
        </button>
        <button class="cd-btn cd-btn-confirm" (click)="confirmService.accept()">
          {{ confirmService.options().confirmLabel }}
        </button>
      </div>
    </div>
  </div>
}
